import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {DashboardPage} from './DashboardPage'

const DashboardWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{'Tableau de bord'}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
